import { Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfigService } from '@core/config.service';
import { get } from 'lodash-es';
import { InterstitialService } from '@app/services/interstitial/interstitial.service';
import { trigger, state, style, animate, transition} from '@angular/animations';
import { ResourceBundleService } from '@app/services/resource-bundle/resource-bundle.service';

@Component({
    selector: 'pixie-modal',
    templateUrl: './pixie-modal.component.html',
    styleUrls: ['./pixie-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('openClose', [
            state('open', style({
                opacity: 1,
                visibility: 'visible',
                transform: 'translateX(0)'
            })),
            state('closed', style({
                visibility: 'hidden'
            })),
            transition('open => closed', [
                animate('300ms 100ms ease-out')
            ]),
            transition('closed => open', [
                animate('400ms 100ms ease-out')
            ]),
        ]),
    ]
})
export class PixieModalComponent implements OnInit {
    link;
    siteId;
    isOpened = false;
    isLoaded = false;

    title: String;
    description: String;
    button = {
        'close': 'Close',
        'continue': 'Continue'
    };

    constructor(
        private sanitizer: DomSanitizer,
        private configService: ConfigService,
        private interstitialService: InterstitialService,
        private resourceBundleService: ResourceBundleService,
    ) {}

    ngOnInit() {
        this.siteId = this.configService.getValue('siteId');
        this.resourceBundleService.get('interstitial').then((resourceBundle) => {
            const content = get(resourceBundle, 'descriptions[0].sections', null);
            if (content) {
                this.isLoaded = true;
                this.title = content.title;
                this.description = content.description;
                this.button.close = content.secondaryButton;
                this.button.continue = content.primaryButton;
            } else {
                console.error('PixieModal Error - Data missing from resource bundle');
            }
        }, (e) => {
            console.error('PixieModal Data Error', e);
        });

        this.interstitialService.getSubject().subscribe((data) => {
                if (data) {
                    this.openModal(data);
                } else {
                    this.hideModal();
                }
            },
            (e) => console.error('PixieModal Error', e)
        );
    }

    openModal(link) {
        if (this.isLoaded) {
            this.isOpened = true;
            this.link = link;
        } else {
            console.error('PixieModal Error - modal not loaded');
        }
    }

    hideModal() {
        this.isOpened = false;
    }

    closeModal(event) {
        event.preventDefault();
        this.interstitialService.closeModal();
    }

}
